import { eachMinuteOfInterval } from 'date-fns';
import { TIME_12, TIME_24 } from 'src/common/constants';
import { sortInstabookTripTimes, timeStringToDateUpdate } from 'src/common/helpers';
import { InstabookAvailability } from 'src/common/types/api/v4/instabook';
import { formatDate } from 'src/common/utils/dateHelpers';
import { DepartureTime } from 'src/listing/types';

const INTERVAL_MINUTES = 15;
const getInstabookDepartureTimes = (
  trip: InstabookAvailability,
  locale: Locale,
): DepartureTime[] => {
  const { instabook_trip_times: tripTimes } = trip;
  // const options: DepartureTime[] = [];
  const options = tripTimes
    .slice()
    .sort(sortInstabookTripTimes)
    .map(({ min_start_time: startTime, max_start_time: endTime }): Date[] => {
      const hasSingleOption = startTime === endTime;
      if (!hasSingleOption) {
        return eachMinuteOfInterval(
          {
          // TODO: should this include the correct date?
            start: timeStringToDateUpdate(startTime),
            end: timeStringToDateUpdate(endTime),
          },
          { step: INTERVAL_MINUTES },
        );
      }
      // TODO: should this include the correct date?
      return [timeStringToDateUpdate(startTime)];
    }).flat()
    .map((dateTime, id): DepartureTime => ({
      formattedTime24: formatDate(dateTime, TIME_24, locale),
      formattedTime12: formatDate(dateTime, TIME_12, locale),
      dateTime,
      tripId: trip.id,
      id: `${id}`,
    }));

  return options;
};

export default getInstabookDepartureTimes;
